var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"context-wrapper"},[_c('hr'),_c('div',{staticClass:"request-panel"},[_vm._v(" "+_vm._s(this.timeInUtc)+" - "+_vm._s(this.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }